import { ReviewAlertPreference } from 'types/communities';

import type { CommunityReviewAlertScopeSettings } from './types';

export enum CommunityReviewAlertScope {
  COMMUNITY = 1,
  COMPETITOR = 2,
}

export enum CommunityReviewAlertMode {
  OVERALL = 1,
  CATEGORY = 2,
}

export const DEFAULT_ALERT_MODE_SETTINGS: ReviewAlertPreference = {
  id: 0,
  mode: CommunityReviewAlertMode.OVERALL,
  number_of_reviews: 2,
  positive: false,
  within_months: 2,
  review_category_id: null,
};

const DEFAULT_SCOPE_SETTINGS: CommunityReviewAlertScopeSettings = {
  mode: CommunityReviewAlertMode.OVERALL,
  overall: { ...DEFAULT_ALERT_MODE_SETTINGS },
  category_settings: {},
  selected_category_ids: [],
};

export const DEFAULT_ALERT_MODE_SETTINGS_BY_SCOPE: Record<
  CommunityReviewAlertScope,
  CommunityReviewAlertScopeSettings
> = {
  [CommunityReviewAlertScope.COMMUNITY]: {
    ...DEFAULT_SCOPE_SETTINGS,
    overall: { ...DEFAULT_ALERT_MODE_SETTINGS },
    category_settings: {},
    selected_category_ids: [],
  },
  [CommunityReviewAlertScope.COMPETITOR]: {
    ...DEFAULT_SCOPE_SETTINGS,
    overall: { ...DEFAULT_ALERT_MODE_SETTINGS },
    category_settings: {},
    selected_category_ids: [],
  },
};

export const REVIEW_ALERT_FILTER_FIELDS = ['number_of_reviews', 'positive', 'within_months'] as const;
export type ReviewAlertFilterField = (typeof REVIEW_ALERT_FILTER_FIELDS)[number];

export const createCategoryAlertPreference = (reviewCategoryId: number): ReviewAlertPreference => {
  return {
    ...DEFAULT_ALERT_MODE_SETTINGS,
    mode: CommunityReviewAlertMode.CATEGORY,
    review_category_id: reviewCategoryId,
  };
};

export const REVIEW_ALERT_REVIEW_COUNT_OPTIONS = [
  { label: '1 And Above', value: 1 },
  { label: '2 And Above', value: 2 },
  { label: '3 And Above', value: 3 },
  { label: '4 And Above', value: 4 },
  { label: '5 And Above', value: 5 },
];

export const REVIEW_ALERT_SENTIMENT_OPTIONS = [
  { label: 'Negative', value: 0 },
  { label: 'Positive', value: 1 },
];

export const REVIEW_ALERT_WITHIN_OPTIONS = [
  { label: '1 Month', value: 1 },
  { label: '2 Months', value: 2 },
  { label: '3 Months', value: 3 },
  { label: '6 Months', value: 6 },
];

export const REVIEW_ALERT_MODE_OPTIONS = [
  { label: 'Overall', value: CommunityReviewAlertMode.OVERALL },
  { label: 'Per Category', value: CommunityReviewAlertMode.CATEGORY },
];
